import styled from 'styled-components'

export const TagContainer = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 6px 12px;
	background-color: ${props => props.theme.colors.brand.backgroundBlue};
	color: ${props => props.theme.colors.brand.blueOmint};
	border-radius: 20px;
	font-size: 14px;
	font-weight: 500;
	white-space: nowrap;
`

export const RemoveButton = styled.button`
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;
	&:hover {
		opacity: 0.7;
	}
`
